var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_404"},[_c('el-result',{attrs:{"icon":"error","title":"404","subTitle":"抱歉，您没有权限访问该页面或该页面不存在。"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary","size":"medium","plain":""},on:{"click":_vm.goLogin}},[_vm._v("返回")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }